import { call, put, takeLatest } from "redux-saga/effects";
import { PettyCashierMonthlyBudgetAction } from "../../actions";
import * as types from "../../actions/actionTypes";
import * as monthlyBudgetApi from "../../api/monthlyBudget/pettyCashierMonthlyBudget";
import { toastr } from "react-redux-toastr";
import { goBack, replace, go } from "connected-react-router";
import { SUMMARY_MONTHLY_BUDGET_PETTY_CASHIER } from "../../constants/urls";
import { SetMessage } from "../../assets/errorMessages";

export function* pettyCashierWatcherMonthlyBudget() {
  yield takeLatest(
    types.PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_REQUEST,
    workerList
  );
  yield takeLatest(
    types.PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_REQUEST,
    workerInit
  );
  yield takeLatest(
    types.PETTY_CASHIER_STORE_MONTHLY_BUDGET_REQUEST,
    workerStore
  );
  yield takeLatest(types.PETTY_CASHIER_SHOW_MONTHLY_BUDGET_REQUEST, workerShow);
  yield takeLatest(types.PETTY_CASHIER_GET_MONTHLY_BUDGET_REQUEST, workerGet);
  yield takeLatest(
    types.PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_REQUEST,
    workerUpdate
  );
  yield takeLatest(
    types.PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_REQUEST,
    workerRemove
  );
}

async function fetchList(pageNumber) {
  return monthlyBudgetApi.getList(pageNumber);
}

function* workerList(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(
      PettyCashierMonthlyBudgetAction.getListSuccess(response.data.data)
    );
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierMonthlyBudgetAction.getListFailure(message));
  }
}

async function fetchInit() {
  return monthlyBudgetApi.getInit();
}

function* workerInit() {
  try {
    const response = yield call(fetchInit);
    yield put(PettyCashierMonthlyBudgetAction.getInitSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierMonthlyBudgetAction.getInitFailure(message));
  }
}

async function fetchStore(data) {
  return monthlyBudgetApi.store(data);
}

function* workerStore(action) {
  try {
    const response = yield call(fetchStore, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(PettyCashierMonthlyBudgetAction.storeSuccess(response.data));
    yield put(
      replace(
        `${SUMMARY_MONTHLY_BUDGET_PETTY_CASHIER}/${response.data.data.id}`
      )
    );
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierMonthlyBudgetAction.storeFailure());
  }
}

async function fetchShow(id) {
  return monthlyBudgetApi.show(id);
}

function* workerShow(action) {
  try {
    const response = yield call(fetchShow, action.id);
    yield put(PettyCashierMonthlyBudgetAction.showSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierMonthlyBudgetAction.showFailure(message));
  }
}

async function fetchGet(data) {
  return monthlyBudgetApi.get(data);
}

function* workerGet(action) {
  try {
    const response = yield call(fetchGet, action.data);
    yield put(PettyCashierMonthlyBudgetAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierMonthlyBudgetAction.getFailure(message));
  }
}

async function fetchUpdate(id, data) {
  return monthlyBudgetApi.update(id, data);
}

function* workerUpdate(action) {
  try {
    const response = yield call(fetchUpdate, action.id, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(PettyCashierMonthlyBudgetAction.updateSuccess(response.data));
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierMonthlyBudgetAction.updateFailure());
  }
}

async function fetchRemove(id) {
  return monthlyBudgetApi.remove(id);
}

function* workerRemove(action) {
  try {
    const response = yield call(fetchRemove, action.id);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(PettyCashierMonthlyBudgetAction.removeSuccess(response.data));
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierMonthlyBudgetAction.removeFailure());
  }
}
